import React from "react";

const LANGS = ["en", "es"];

const COMPACT = {
  wrap: "hidden sm:flex items-center border border-brand text-xs font-display font-bold overflow-hidden",
  btn: "px-2.5 py-1.5 transition-colors",
  active: "bg-brand-primary text-white",
  idle: "bg-white text-brand-primary hover:bg-slate-50",
};

const WIDE = {
  wrap: "flex gap-2 pt-3",
  btn: "flex-1 py-2 text-sm font-display font-bold border",
  active: "bg-brand-primary text-white border-brand-primary",
  idle: "bg-white text-brand-primary border-brand",
};

export const LangToggle = ({ lang, setLang, variant = "compact", testIdPrefix = "lang" }) => {
  const s = variant === "wide" ? WIDE : COMPACT;
  return (
    <div data-testid={`${testIdPrefix}-toggle`} className={s.wrap}>
      {LANGS.map((code) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          data-testid={variant === "wide" ? `mobile-lang-${code}` : `lang-${code}-btn`}
          className={`${s.btn} ${lang === code ? s.active : s.idle}`}
        >
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
